"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnaAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const ImageCardUrl_1 = require("../../../_shared/constants/ImageCardUrl");
const CardHelper_1 = require("../../../_shared/utils/CardHelper");
const QnaAppealCard = (qna) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: qna.state !== "closed" ? "Q&A Started" : "Q&A",
        wrap: true,
        size: adaptivecards_1.TextSize.Large,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "Select the Polly icon in the meetings toolbar at the top to participate and asks questions.",
        spacing: adaptivecards_1.Spacing.Medium,
        wrap: true,
    }));
    card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.Image, {
        url: ImageCardUrl_1.SharedImageCardUrl.OPEN_SIDE_PANEL,
    }));
    return card;
};
exports.QnaAppealCard = QnaAppealCard;
//# sourceMappingURL=QnaAppealCard.js.map